import gql from 'graphql-tag';
import { type GetMableFeesQuery } from 'src/app/shared/graphql/agreements/mable-fees-query.graphql.autogenerated';

export type GetMableFeesQueryResult = GetMableFeesQuery['mableFees'];

export const GetMableFeesDocument = gql`
  query getMableFees($agreementId: ID) {
    mableFees(agreementId: $agreementId) {
      clientFeePercentage
      workerFeePercentage
    }
  }
`;
